module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg3-2c5411d9866c479032e685737799981c.svg";